import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { RouterView } from 'vue-router';
import Web3Board from './ethers/components/Board.vue';
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
import Icons from '@/components/Icon/Icons.vue';
import { currentLocale } from '@/locales/i18n';
import { router } from '@/routes';
import { GlobalStore } from '@/store/GlobalStore';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isMobile, } = GlobalStore;
const curretPage = computed(() => router.currentRoute.value.name);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["app", [_unref(isMobile) ? 'mobile' : 'desktop', _unref(curretPage), _unref(currentLocale)]])
    }, [
      _createVNode(Header),
      _createVNode(_unref(RouterView)),
      _createVNode(Footer),
      _createVNode(Icons)
    ], 2),
    _createVNode(Web3Board)
  ], 64))
}
}

})